import apiUtils from '../apiUtils';

const service = {};
const serviceName = 'menu';

service.get = () => {
  return apiUtils.exec(serviceName);
};

export default service;